var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-select-field",
    _vm._b(
      {
        attrs: {
          placeholder: _vm.placeholderText,
          "data-qa": `multi-checkbox-field:${_vm.displayName}`,
        },
      },
      "custom-select-field",
      { ..._vm.$attrs, ..._vm.$props },
      false
    ),
    _vm._l(_vm.optionsArray, function (option) {
      return _c(
        "div",
        { key: `multi-checkbox-item-${option.value}` },
        [
          _c("checkbox-field", {
            attrs: {
              value: _vm.value,
              "display-name": option.name,
              "checked-value": option.value,
              "read-only": option.readOnly,
              disabled: option.disabled,
              inline: true,
              condensed: true,
              "data-qa": `multi-checkbox-item:${option.name}`,
            },
            on: { input: _vm.onInput },
          }),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }